import { useGetPublicationQuery } from 'features/publications/publicationApi';

/**
 * @param {number} [id]
 * @returns {import('../../../models/publications.models').Publication | undefined}
 */
export function useGetPublication(id) {
    const { publication } = useGetPublicationQuery(id, {
        selectFromResult: ({ currentData }) => ({
            publication: currentData,
        }),
        skip: id === 0 || id === undefined,
        refetchOnMountOrArgChange: 60,
        pollingInterval: 30000, // refresh every 30 seconds if window has focus
        skipPollingIfUnfocused: true,
    });

    return publication;
}
